import { render, staticRenderFns } from "./ReceivePrintDetails_Company.vue?vue&type=template&id=01ca93ba&"
import script from "./ReceivePrintDetails_Company.vue?vue&type=script&lang=js&"
export * from "./ReceivePrintDetails_Company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports